import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    document.title = 'Tracker Group LLC | Digital Educational Resources';
  }, []);
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return <div className="flex min-h-screen w-full flex-col bg-paper" data-id="element-141" data-mp="27j6ifb2ewtv">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-ink focus:px-4 focus:py-2 focus:text-paper" data-id="element-142" data-mp="gzlaobk64bzp">
        Skip to content
      </a>
      <Header data-id="element-143" data-mp="3km28ewwi4avx" />
      <main id="main" className="flex-1" data-id="element-144" data-mp="3klind7bk16do">
        <Outlet data-id="element-145" data-mp="3fp22clznj84t" />
      </main>
      <Footer data-id="element-146" data-mp="3fnqxsjydtwcn" />
    </div>;
}